import React, { useEffect, useState } from "react";

import loading from "../../../callback/loading.svg";

import { Input } from "../../inputs";
import { useInput } from "../../../../shared/hooks/form-fields";
import { searchTaxonomy } from "../lib/data";

var searchTabTimer = null;

const boldString = (str, query) => {
    const n = str.toUpperCase();
    const q = query.toUpperCase();
    const x = n.indexOf(q);

    if (!q || x === -1) {
        return str; // bail early
    }

    const l = q.length;

    return str.substr(0, x) + "<b>" + str.substr(x, l) + "</b>" + str.substr(x + l);
};

var lastCall = "";

const SearchTab = (props) => {
    const searchInput = useInput("");
    const [searching, setSearching] = useState(false);
    const [searchState, setSearchState] = useState({
        hasSearched: false,
        term: "",
        options: [],
    });

    useEffect(() => {
        clearTimeout(searchTabTimer);

        if (searchInput.value.length >= 3) {
            searchTabTimer = setTimeout(() => {
                handleSearch();
            }, 900);
        } else {
            setSearchState({
                ...searchState,
                options: [],
            });
        }
    }, [searchInput.value]);

    const handleSearch = async () => {
        const timestamp = new Date().getTime();
        lastCall = timestamp;
        setSearching(true);

        const searchTerm = searchInput.value;
        const results = await searchTaxonomy(searchTerm);

        if (timestamp === lastCall) {
            setSearchState({
                hasSearched: true,
                term: searchTerm,
                options: results,
            });
            setSearching(false);
        }
    };

    const onCancel = () => {
        searchInput.reset();
    };

    const htmlOptions = searchState.options.map((o, i) => {
        const boldedString = boldString(o.pathing, searchState.term);

        return (
            <li key={`${searchState.term}_${i}`}>
                <button
                    className="button -text"
                    onClick={() => {
                        props.updateSelected(o);
                    }}
                    dangerouslySetInnerHTML={{ __html: boldedString }}
                ></button>
            </li>
        );
    });
    const statusHTML = searching ? (
        <div className="status txt-center">
            <img src={loading} alt="loading" />
        </div>
    ) : null;

    return (
        <div className="tab-search">
            <div className="input-group -no-margin">
                <Input {...searchInput.bind} placeholder="Search" autoFocus={true} onCancel={onCancel} />
                <h5 className="txt-right">{searchState.options.length} results</h5>
            </div>
            <div className="content">
                <ul className="options-list">{htmlOptions}</ul>
                {statusHTML}
            </div>
        </div>
    );
};

export default SearchTab;
